import { Box } from "@repo/components/src/ui/box";
import { HStack } from "@repo/components/src/ui/hstack";
import { Icon } from "@repo/components/src/ui/icon";
import { Pressable } from "@repo/components/src/ui/pressable";
import { Text } from "@repo/components/src/ui/text";
import { VStack } from "@repo/components/src/ui/vstack";
import { PersonKindEnum } from "@repo/graphql/gql/graphql";
import { Building2, Check, UserRound } from "lucide-react-native";

import type { RegimeOption } from "./types";

type Props = {
  regime: RegimeOption;
  /** The copy to show; a payer reads the payer-facing text of the regime. */
  label: string;
  description: string;
  selected: boolean;
  onSelect: () => void;
};

export default function RegimeCard({
  regime,
  label,
  description,
  selected,
  onSelect,
}: Props) {
  const regimeIcon =
    regime.personKind === PersonKindEnum.Company ? Building2 : UserRound;

  return (
    <Pressable
      onPress={onSelect}
      accessibilityRole="radio"
      accessibilityState={{ selected }}
    >
      {(pressableProps) => (
        <HStack
          space="md"
          className={`items-start rounded-2xl border p-4 ${
            selected
              ? "bg-brand-50 border-brand-400"
              : pressableProps.pressed
                ? "bg-brand-50/40 border-brand-50"
                : "border-outline-100"
          }`}
        >
          <Box className="rounded-xl items-center justify-center w-10 h-10 bg-brand-50">
            <Icon as={regimeIcon} size="sm" className="text-brand-400" />
          </Box>
          <VStack className="flex-1" space="xs">
            <Text
              bold
              className={`text-[15px] tracking-tight ${
                selected ? "text-brand-400" : "text-typography-950"
              }`}
            >
              {label}
            </Text>
            <Text size="xs" className="text-typography-600 leading-[17px]">
              {description}
            </Text>
          </VStack>
          <Box
            className={`rounded-full items-center justify-center w-[22px] h-[22px] mt-[2px] ${
              selected
                ? "bg-brand-400"
                : "bg-white border-[1.5px] border-outline-200"
            }`}
          >
            {selected ? (
              <Icon as={Check} size="2xs" className="text-white" />
            ) : null}
          </Box>
        </HStack>
      )}
    </Pressable>
  );
}
